export default __webpack_public_path__ + "static/media/villagers-win.654e102f.mp3";